export enum Ratio {
  PERCENTAGE,
  PER_THOUSAND,
}
